import React, { useEffect, useState } from "react";
import { DimensionModel } from "../../_core/_model";
import { useAppContext } from "../../context/AppContext.tsx";

interface request {
    onChange: (v: string) => void,
    iniVal: string
}
export function DiensionDropdown({ onChange, iniVal }: request) {
    const [items, setItems] = useState<DimensionModel[]>([]);
    const [curVal, setCurVal] = useState("");
    const { dimensions } = useAppContext();
    useEffect(() => {
        setItems([...dimensions]);
    }, [])

    useEffect(() => {
        setCurVal(iniVal)
    }, [iniVal])
    return (
        <select className="form-select" onChange={(e) => { onChange(e.target.value) }} value={curVal}>
            <option value={""} disabled>Select a Dimension</option>
            {
                items.map((d) => (
                    <option key={d.dimensionCode} value={d.dimensionCode}>{d.dimensionName}</option>
                ))
            }
        </select>
    )
}

export default DiensionDropdown;